<html lang="fr">
<head>
    <title>CodinCloud - Changer le Mot de Passe</title>
</head>
<body>

<div class="container">
    <img src="../../../assets/Vendeur-site-smallversion2.png" alt="CodinCloud Logo" class="logo1">
    <img src="../../../assets/icon-vendeur-transparent-01.png" alt="CodinCloud Logo" class="logo">
        <h3>Changer votre mot de passe</h3>
    <form [formGroup]="changePasswordForm" (ngSubmit)="onChangePasswordSubmit()">
        <label for="newPassword">Nouveau mot de passe</label>
        <input matInput type="password" id="newPassword" formControlName="newPassword" placeholder="Entrez votre nouveau mot de passe" required>

        <label for="confirmPassword">Confirmer le nouveau mot de passe</label>
        <input matInput type="password" id="confirmPassword" formControlName="confirmPassword" placeholder="Confirmez votre nouveau mot de passe" required>

        <button mat-raised-button color="primary" type="submit" [disabled]="changePasswordForm.invalid">Changer le mot de passe</button>
    </form>

    <!-- Affichage du message de réponse -->
    <div *ngIf="message" class="response-message">
        <p>{{ message }}</p>
    </div>
</div>
</body>
</html>
